import { cloneDeep } from 'lodash';
import { LOCALIZE_KEYS } from '../localization/fieldsettingsKey';

const generateSnakeKey = (str) => str
  .toLowerCase()
  .replace(/[^\w\s]/g, '')
  .trim()
  .replace(/\s+/g, '_');

export function wrappedLocalizeField(t, settings) {
  const localized = { ...settings };

  Object.keys(localized).forEach((sectionKey) => {
    // Skip 'custom field setting'
    if (sectionKey === 'custom') {
      return;
    }

    const section = localized[sectionKey];
    if (section && section.attributes) {
      Object.keys(section.attributes).forEach((fieldKey) => {
        const field = section.attributes[fieldKey];
        if (field && field.label) {
          const snakeKey = generateSnakeKey(fieldKey);
          const translationKey = `fieldsetting.${snakeKey}`;
          field.label = t(translationKey, field.label);
        }
        if (field && field.input_type === 'dropdown' && Array.isArray(field.options)) {
          field.options = field.options.map((option) => {
            if (option.label) {
              const optionSnakeKey = generateSnakeKey(option.name);
              const optionTranslationKey = `fieldsetting.${fieldKey}-options.${optionSnakeKey}`;
              return {
                ...option,
                label: t(optionTranslationKey, option.label),
              };
            }
            return option;
          });
        }
      });
    }
  });
  return null;
}

export function swapLocalizeToEn(payload, t) {
  // cloneDeep preventing original payload getting mutated as well
  const transformed = cloneDeep(payload);

  Object.keys(transformed).forEach((sectionKey) => {
    // Skip 'custom field setting'
    if (sectionKey === 'custom') {
      return;
    }
    const section = transformed[sectionKey];
    if (!section?.attributes) {
      return;
    }

    Object.keys(section.attributes).forEach((attrKey) => {
      const attr = section.attributes[attrKey];
      const localizeKey = LOCALIZE_KEYS[attrKey];

      if (localizeKey && attr?.label) {
        attr.label = t(localizeKey, { lng: 'en' });
      }

      if (attr?.input_type === 'dropdown' && Array.isArray(attr.options)) {
        attr.options = attr.options.map((option) => {
          const optionKey = `${attrKey}-options.${option.name}`;
          const optionLocalizeKey = LOCALIZE_KEYS[optionKey];

          if (optionLocalizeKey && option.label) {
            return {
              ...option,
              label: t(optionLocalizeKey, { lng: 'en' }),
            };
          }
          return option;
        });
      }
    });
  });

  return transformed;
}
